/* eslint-disable */
import React, {useEffect, useRef, useState} from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { Translate, Translator } from 'react-translated';
import { setHasChanges, error, success, clearMessages } from '../../../store/actions/globalMessagesActions';

import { Row, Col, Table, Spinner, Button, ButtonToolbar, Form } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencilAlt, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../misc/Pagination';
import { messagesTableActions } from '../../../store/actions/messagesTableActions';
import AddEditMessages from './AddEditMessages';
function DeleteConfirmation({result}) {
    const dispatch = useDispatch();

    const handleDelete1 = (result) => {
        const deleteData = JSON.parse(JSON.stringify(result));
        deleteData.changeType = 'DELETE';
        dispatch(messagesTableActions.updateMessageTable('adminmessage', deleteData, 'message_delete'));
    };

    return (
        <ButtonToolbar className={'float-right'}>
            <Button onClick={() => dispatch(clearMessages())}>
                <Translate text={'Cancel'} />
            </Button>
            <Button variant={'danger'} onClick={() => handleDelete1(result)}>
                <Translate text={'Delete'} />
            </Button>
        </ButtonToolbar>
    );
}

function Messages({ isActive, currentPage, setCurrentPage, resultsNum, setResultsNum }) {
    const {
        BLANK_VALUE,
        ADMIN_MESSAGES_PAGINATION_LIMIT
    } = require('../../../config/constants');
    const dispatch = useDispatch();

    // State data
    const authenticate = useSelector(state => state.authenticate);
    const getMessageTable = useSelector(state => state.getMessageTable, shallowEqual);
    const postMessageTable = useSelector(state => state.postMessageTable);
    const [results, setResults] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [isResultsLoading, setIsResultsLoading] = useState(false);
    const [noResultsMessage, setNoResultsMessage] = useState('\u00A0');
    const [currentResult, setCurrentResult] = useState(false);
    const [editForm, setEditForm] = useState(false);
    const [data, setData] = useState({
        'changeType': 'SAVE',
        'headline': '',
        'audience': '',
        'body': '',
        'id': null,
        'enabled': false
    });
    const resultsRef = useRef(null);

    const handleEditResult = (result) => {
        setCurrentResult(result);
        setEditForm(true);
    };
        const handleDelete = (result) => {
        setCurrentResult(result);
        dispatch(success('Are you sure you would like to delete this?', <DeleteConfirmation result={result}/>));
        setEditForm(false);
    };

    const handleAddRow = () => {
        setCurrentResult({});
        setData({
            'changeType': 'SAVE',
            'headline': '',
            'audience': '',
            'body': '',
            'id': null,
            'enabled': false })
        setEditForm(true);
    };

    const handleCloseForm = () => {
        setCurrentResult(false);
        setEditForm(false);
    };

    // Getting data.
    const loadData = () => {
        setResults([]);
        setIsResultsLoading(true);
        dispatch(messagesTableActions.getMessageTable(
            'adminmessages',
            {
                page: currentPage,
                numberOfRecords: resultsNum
            },
            true
        ));
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleResultsChange = (newNum) => {
        setCurrentPage(1);
        setResultsNum(newNum);
    };

    useEffect(() => {
        if (!isActive) {
            setCurrentResult(false);
            setEditForm(false);
        }
    }, [isActive]);

    useEffect(() => {
        if (authenticate && authenticate.success) {
            loadData();
        }
    }, [currentPage, authenticate, resultsNum]);

    // Listening to users state.
    useEffect(() => {
        if (getMessageTable.request) {
            setNoResultsMessage('\u00A0');
        } else if (getMessageTable.error) {
            setNoResultsMessage('Error loading results');
            setIsResultsLoading(false);
        }
        if (getMessageTable.success && getMessageTable.adminmessages) {
            if (getMessageTable.adminmessages.adminDataResponseDataList && getMessageTable.adminmessages.adminDataResponseDataList.length) {
                setResults(getMessageTable.adminmessages.adminDataResponseDataList);
                setPaginationData(getMessageTable.adminmessages.paginationData);
            } else {
                setResults([]);
                setPaginationData(false);
                setNoResultsMessage('No results found');
            }

            setIsResultsLoading(false);
        }
    }, [getMessageTable]);

    // Updated changes.
    useEffect(() => {
        if (postMessageTable.success && postMessageTable.callback === 'messages') {
            dispatch(success('Messages successfully updated.', null, () => { resultsRef.current.focus(); }));
            setIsResultsLoading(true);
            setCurrentPage(1);
            setCurrentResult({});
            setData({ 'changeType': 'SAVE',
                'headline': '',
                'audience': '',
                'body': '',
                'id': null,
                'enabled': false})
            loadData();
            dispatch(setHasChanges(false));
            dispatch(messagesTableActions.resetUpdateMessageTable());
        } else if (postMessageTable.error && postMessageTable.callback === 'messages') {
            if (postMessageTable.status == 302) {
                dispatch(error('One message per audience type can be published at a time. Please save the existing message as draft before publishing the new one.'));
                setCurrentResult(data);
                setEditForm(true);
            } else {
                dispatch(error('Error: Messages could not be updated. Please try again later.', null, () => { resultsRef.current.focus(); }));
                dispatch(messagesTableActions.resetUpdateMessageTable());
                setCurrentResult({});
                setData({ 'changeType': 'SAVE',
                'headline': '',
                'audience': '',
                'body': '',
                'id': null,
                'enabled': false})
            }
        } else if (postMessageTable.success && postMessageTable.callback === 'message_delete') {
            dispatch(success('Message successfully deleted.', null, () => { resultsRef.current.focus(); }));
            setIsResultsLoading(true);
            setCurrentPage(1);
            setCurrentResult({});
            setData({ 'changeType': 'SAVE',
                'headline': '',
                'audience': '',
                'body': '',
                'id': null,
                'enabled': false})
            loadData();
            dispatch(setHasChanges(false));
            dispatch(messagesTableActions.resetUpdateMessageTable());
        }
    }, [postMessageTable]);

    return (
        <>
            { editForm &&
				<AddEditMessages handleCloseForm={ handleCloseForm } result={ currentResult } data={data} setData={setData} />
			}
            { editForm === false &&
                <>
                    <Row>
                        <Col md={12}>
                            <ButtonToolbar className="justify-content-end">
                                <div style={{ marginTop: '40px' }}>
                                    <Button variant="primary" onClick={() => handleAddRow()}>
                                        <Translate text={'Add Message'} />
                                    </Button>
                                </div>
                            </ButtonToolbar>
                        </Col>
                    </Row>

                    <Row className={'mt-0'}>
                        <Col>
                            { isResultsLoading &&
                                <div className="text-center m-3">
                                    <Spinner animation="border" role="status" className="loader">
                                        <span className="sr-only"><Translate text={'Loading'} /></span>
                                    </Spinner>
                                </div>
                            }

                            {(!isResultsLoading && results && results.length > 0) &&
                                <>
                                    <Table bordered hover responsive ref={ resultsRef } className={'message-table'}>
                                        <thead>
                                            <tr>
                                                <th><Translate text={'Headline'} /></th>
                                                <th><Translate text={'Audience'} /></th>
                                                <th><Translate text={'Status'} /></th>
                                                <th hidden><Translate text={'Controls'} /></th>
                                            </tr>
                                        </thead>

                                        { results &&
                                            <tbody>
                                                {
                                                    results.map((result, index) => {
                                                        return (
                                                            <tr key={ index }>
                                                                <td>{ (result.headline) ? result.headline : BLANK_VALUE }</td>
                                                                <td>{ (result.audience) ? result.audience : BLANK_VALUE }</td>
                                                                <td><Translate text={(result.enabled) ? 'Published' : 'Draft'} /></td>
                                                                <td className={'row-actions'}>
                                                                    <div className={'row-actions-buttons text-left'}>
                                                                        <div>
                                                                            <Button
                                                                                variant="link"
                                                                                className={'mb-0'}
                                                                                onClick={() => handleEditResult(result)}
                                                                            >
                                                                                <FontAwesomeIcon icon={ faPencilAlt } />
                                                                            </Button>
                                                                            {!result.enabled && <Button variant="link" className={'mb-0'} onClick={() => handleDelete(result)}>
                                                                                <FontAwesomeIcon icon={ faTimesCircle } />
                                                                                <span className="sr-only"><Translate text={'Remove'} /></span>
                                                                            </Button>}
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        }
                                    </Table>

                                    <Row className="align-items-center">
                                        { paginationData &&
                                            <Col md={6} className="text-center text-md-left">
                                                <Pagination
                                                    data={ paginationData }
                                                    handlePaginationChange={ handlePageChange }
                                                />
                                            </Col>
                                        }

                                        <Col md={(paginationData) ? 6 : 12} className="text-center text-md-right">
                                            <label className="sort-control">
                                                <span><Translate text="Results" /></span>
                                                <Form.Control
                                                    as="select"
                                                    value={ resultsNum }
                                                    onChange={(e) => { handleResultsChange(e.target.value); }}
                                                >
                                                    <Translator>
                                                        {({ translate }) => (
                                                            <>
                                                                <option value={ADMIN_MESSAGES_PAGINATION_LIMIT}>
                                                                    { translate({ text: `${ADMIN_MESSAGES_PAGINATION_LIMIT}` }) }
                                                                </option>
                                                                <option value={25}>
																	{ translate({ text: '25' }) }
																</option>
																<option value={50}>
																	{ translate({ text: '50' }) }
																</option>
																<option value={100}>
																	{ translate({ text: '100' }) }
																</option>
                                                            </>
                                                        )}
                                                    </Translator>
                                                </Form.Control>
                                            </label>
                                        </Col>
                                    </Row>
                                </>
                            }

                            { !isResultsLoading && noResultsMessage && (!results || results.length <= 0) &&
                                <div className={'alerts-container'}>
                                    <Alert variant="light">
                                        <span className="alert-message"><Translate text={ noResultsMessage } /></span>
                                    </Alert>
                                </div>
                            }
                        </Col>
                    </Row>
                </>
            }
        </>
    );
}

export default Messages;
